import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { useCurrency } from '../context/CurrencyContext';
import { Menu, X, ShoppingBag } from 'lucide-react';
import './Header.css';

function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { cartItems } = useCart();
  const { currency, toggleCurrency } = useCurrency();

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="header-logo" data-testid="header-logo">
          <img 
            src="/logo-final.png" 
            alt="Binding Thread logo — a needle and thread forming a heart" 
            className="logo-svg"
            width="200"
            height="60"
          />
        </Link>

        {/* Desktop Navigation */}
        <nav className="header-nav desktop-nav">
          <Link to="/" className="nav-link" data-testid="nav-home">Home</Link>
          <Link to="/shop" className="nav-link" data-testid="nav-shop">Shop</Link>
          <Link to="/about" className="nav-link" data-testid="nav-about">About Us</Link>
          <Link to="/how-it-works" className="nav-link" data-testid="nav-how-it-works">How It Works</Link>
          <Link to="/faq" className="nav-link" data-testid="nav-faq">FAQs</Link>
          <Link to="/blog" className="nav-link" data-testid="nav-blog">Blog</Link>
        </nav>

        <div className="header-actions">
          <button
            className="currency-toggle"
            onClick={toggleCurrency}
            data-testid="currency-toggle"
            title={`Switch to ${currency === 'AUD' ? 'USD' : 'AUD'}`}
          >
            {currency === 'AUD' ? '🇦🇺 AUD' : '🇺🇸 USD'}
          </button>

          <Link to="/shop" className="cart-icon" data-testid="cart-icon">
            <ShoppingBag size={20} />
            {cartItems.length > 0 && (
              <span className="cart-count" data-testid="cart-count">{cartItems.length}</span>
            )}
          </Link>

          <button 
            className="mobile-menu-toggle"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-toggle"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {mobileMenuOpen && (
        <nav className="mobile-nav" data-testid="mobile-nav">
          <Link to="/" className="mobile-nav-link" onClick={() => setMobileMenuOpen(false)}>Home</Link>
          <Link to="/shop" className="mobile-nav-link" onClick={() => setMobileMenuOpen(false)}>Shop</Link>
          <Link to="/about" className="mobile-nav-link" onClick={() => setMobileMenuOpen(false)}>About Us</Link>
          <Link to="/how-it-works" className="mobile-nav-link" onClick={() => setMobileMenuOpen(false)}>How It Works</Link>
          <Link to="/faq" className="mobile-nav-link" onClick={() => setMobileMenuOpen(false)}>FAQs</Link>
          <Link to="/blog" className="mobile-nav-link" onClick={() => setMobileMenuOpen(false)}>Blog</Link>
        </nav>
      )}
    </header>
  );
}

export default Header;
